import React, { useState, useEffect, useCallback } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography, Box } from '@mui/material';
import { useAppSelector } from '../../hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { BasicDataTypes } from '../../types/types';

const VisaFilter: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { data } = useAppSelector(state => state.frontViewData);
    const [visaTypes, setVisaTypes] = useState<BasicDataTypes[]>([]);
    const [selectedValue, setSelectedValue] = useState<string>('');

    useEffect(() => {
        if (data && data.data) {
            const fetchedData = data.data;
            const visaData = fetchedData?.visaTypes || [];
            setVisaTypes(visaData);
        }
    }, [data]);

    const handleVisaTypeChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = event.target.value;
            setSelectedValue(newValue);
            const searchParams = new URLSearchParams(location.search);
            searchParams.delete('page');
            searchParams.set('visa', newValue);
            navigate(`?${searchParams.toString()}&page=1`);
        },
        [location.search, navigate]
    );

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const visaParam = searchParams.get('visa');
        if (visaParam) {
            setSelectedValue(visaParam);
        }        
    }, [location.search]);

    return (
        <Box>
            <Typography sx={{ mb: 3 }}>Visa Types</Typography>
            <FormControl>
                <RadioGroup
                    aria-labelledby="visa-filter-label"
                    value={selectedValue}
                    onChange={handleVisaTypeChange}
                    name="visa-filter-group"
                >
                    {visaTypes.map((visa) => (
                        <FormControlLabel
                            key={visa.id}
                            value={String(visa.id)}
                            control={<Radio />}
                            label={visa.name}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default VisaFilter;
